import React from 'react'

interface Alert {
  type: 'warning' | 'info' | 'error'
  title: string
  message: string
  timestamp: string
}

interface AlertsListProps {
  alerts: Alert[]
}

const AlertsList: React.FC<AlertsListProps> = ({ alerts }) => {
  const getAlertColor = (type: string) => {
    switch (type) {
      case 'error':
        return 'text-red-600 bg-red-50 border-red-200'
      case 'warning':
        return 'text-yellow-600 bg-yellow-50 border-yellow-200'
      default:
        return 'text-blue-600 bg-blue-50 border-blue-200'
    }
  }

  return (
    <div className="space-y-3">
      {alerts.length === 0 ? (
        <p className="text-gray-500 text-sm">No system alerts</p>
      ) : (
        alerts.map((alert, index) => (
          <div key={index} className={`p-3 rounded border ${getAlertColor(alert.type)}`}>
            <div className="flex items-start">
              <div className="flex-1">
                <p className="text-sm font-medium">{alert.title}</p>
                <p className="text-sm">{alert.message}</p>
                <p className="text-xs mt-1">{alert.timestamp}</p>
              </div>
            </div>
          </div>
        ))
      )}
    </div>
  )
}

export default AlertsList 